<template>
    <div class="connect-service">
        <div class="connect_to_stripe_box w100" v-if="config && config.token && config.token !== ''">
            <h3>Connected to {{attributes.caption}}</h3>
            <div class="connect_to_stripe_box_innner connect">
                <p>Click the <b>"Disconnect"</b> button below to restrict access to {{attributes.caption}}</p>
                <slot name="disconnect"></slot>
            </div>
        </div>

        <div class="connect_to_stripe_box w100" v-else>
            <h3>Connect to {{attributes.caption}}</h3>
            <div class="connect_to_stripe_box_innner connect">

	            <p v-if="attributes.name==='google_sheets'">Click the <b>"Sign in with Google"</b> button below to authorize Funnelish to access your google sheets.</p>
	            <p v-else>Click the <b>"Connect"</b> button below to authorize Funnelish to access {{attributes.caption}}</p>

              <slot name="connect"></slot>
            </div>
        </div>

        <p>Feel free to contact us or start a new thread in
            <a href="https://community.funnelish.com" target="_blank">the community</a>
            if you have any questions about setting up or using this integration.
        </p>
    </div>
</template>

<script>
export default {
    name: 'connect-service',
    props: ['attributes', 'config'],
}
</script>
<style lang="scss" scoped>
.connect-service {
	margin-top: 15px;
	margin-bottom: 15px;
	padding: 15px;
	border-radius: 10px;
	background: $light-blue;
	h3 {
		font-weight: 600;
		font-size: 14px;
		color: #57585D;
	}

}
</style>
